// make a given rgba value transparent
export default function setHidden(pixel) {
  // @ts-ignore
  pixel[3] = 0; // @ts-ignore

  return pixel;
}